
import '@src/scss/components/Form.scss';
import kookuIcon from '@src/assets/logo.svg';
const CoreForm=({title='',children,parentClass='',showImage=true}) => (
        <div className={['core-form-wrapper',parentClass].join(' ')}>
            
                {
                      showImage? (
                                <img className="base-logo" src={kookuIcon} alt="kooku-icon"/>
                                ):null
                }
                { title? <h2 className="title">{title}</h2> : '' } 
                {children}    
        
        </div>
    )

export {CoreForm};